import { MultiDietReviewsCarousel } from "@/features/static-builder/components/multidiet-reviews-carousel";
import type { MultiDietReviewsType } from "@/features/static-builder/types/multidiet-reviews.type";
import { strapiUrl } from "@/lib/strapi";
import { cn } from "@/lib/utils";

type Props = {
  data: MultiDietReviewsType;
  className?: string;
};

export const MultiDietReviews = ({ data, className }: Props) => {
  const strapiImages = data.reviews.map((review) =>
    strapiUrl(review.image.url),
  );
  if (!strapiImages) {
    return null;
  }

  return (
    <section className={cn("container my-18 md:my-30", className)}>
      <MultiDietReviewsCarousel data={data} strapiUrl={strapiImages} />
    </section>
  );
};
